import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import { headingsSchema } from '../Header';
import GeographicAllocationMap from './GeographicAllocationMap';

const schema: JSONSchema7 = {
    title: 'Geographic Allocation Map',
    type: 'object',
    required: ['dataKey', 'countryNameKey', 'countryValueKey'],
    properties: {
        styles: {
            type: 'string',
            description: 'A stylesheet',
            default: '',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        mapTitles: headingsSchema,
        dataKey: {
            type: 'string',
            title: 'Enter Data Key',
            default: '',
        },
        dataLimit: {
            type: 'number',
            title: 'Enter number of countries to show',
            default: 10,
        },
        countryNameKey: {
            type: 'string',
            title: 'Enter Data Key For Country Name',
            default: 'holding',
        },
        countryValueKey: {
            type: 'string',
            title: 'Enter Data Key For Country Value',
            default: 'allocation',
        },
        countryCodeKey: {
            type: 'string',
            title: 'Enter Data Key For Country Code',
            default: 'country.entityId',
        },
        colors: {
            type: 'string',
            title: 'Enter Colors JSON array',
            default: '',
        },
        options: {
            type: 'array',
            title: 'Enter Map Options',
            items: {
                type: 'object',
                properties: {
                    path: { type: 'string', description: 'Enter Options Object Path' },
                    value: {
                        type: 'string',
                        description: 'Enter HighChart Maps Options as JSON string',
                    },
                },
            },
        },
        showOtherRegions: {
            type: 'boolean',
            title: 'Show Other regions in the map',
            default: false,
        },
        disableTabStaticData: {
            type: 'boolean',
            title: 'Disable tabbing through static data',
            description: '',
        },
    },
    dependencies: {
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: [
            'mapTitles',
            'dataKey',
            'dataLimit',
            'countryNameKey',
            'countryValueKey',
            'countryCodeKey',
            'colors',
            'options',
            'showOtherRegions',
        ],
        Accessibility: ['disableTabStaticData'],
    },
];

const uiSchema = {
    'ui:groups': groups,
    ...customSchemas.textSchema.TextSchema.uiSchema,
    ...customSchemas.styleSchema.StyleSchema.uiSchema,
    ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
    styles: {
        'ui:widget': 'CSSEditor',
    },
    mapTitles: {
        items: {
            headerText: {
                'ui:widget': 'ResourcePicker',
            },
        },
    },
    dataKey: {
        'ui:widget': 'ResourcePicker',
    },
    dataLimit: {
        'ui:widget': 'CustomTextInput',
    },
    countryNameKey: {
        'ui:widget': 'ResourcePicker',
    },
    countryValueKey: {
        'ui:widget': 'ResourcePicker',
    },
    countryCodeKey: {
        'ui:widget': 'ResourcePicker',
    },
    colors: {
        'ui:widget': 'CustomTextInput',
    },
    options: {
        items: {
            path: { 'ui:widget': 'CustomTextInput' },
            value: { 'ui:widget': 'CustomTextInput' },
        },
    },
    showOtherRegions: {
        'ui:widget': 'CustomCheckbox',
    },
    disableTabStaticData: { 'ui:widget': 'CustomCheckbox' },
};

const GeographicAllocationMapWidget: commonTypes.IWidget = {
    schema,
    uiSchema,
    templateView: GeographicAllocationMap,
    id: 'GeographicAllocationMap',
    group: 'graphics',
    contentPlaceHolders: [],
    initialData: () => ({}),
};

export default GeographicAllocationMapWidget;
